import StoreBadges from '../common/store_badges';
import Viewer from 'viewerjs';

document.addEventListener('DOMContentLoaded', () => {
  const indexDiv = document.querySelector('.coupons_index') as HTMLElement;

  if (indexDiv == null) {
    return;
  }

  const onClickActionsForAllButtons = () => {
    const destroyAllButton = document.querySelector('.destroy-all-button') as HTMLElement;
    const publishAllButton = document.querySelector('.publish-all-button') as HTMLElement;
    onClickActionsForAllButton(destroyAllButton, '本当に削除しますか？');
    onClickActionsForAllButton(publishAllButton, '本当に公開しますか？');
  }

  const onClickActionsForAllButton = (button: HTMLElement, confirmMessage: string) => {
    const form = document.getElementById('leaflet_action_for_all');
    button.addEventListener('click', () => {
      const path = button.dataset.path as string;
      (form as HTMLElement).setAttribute('action', path);
      if (confirm(confirmMessage)) {
        (form as HTMLFormElement).submit();
      }
    });
  }

  const viewerInit = () => {
    const leafletThumbnails = document.querySelectorAll('.leaflet-thumbnail-image');

    leafletThumbnails.forEach(leafletThumbnail => {
      const image = (leafletThumbnail as HTMLElement).querySelector('img') as HTMLElement;
      if (image) {
        const viewer = new Viewer(image, {
          title: false,
          toolbar: {
            zoomIn: true,
            zoomOut: true,
            oneToOne: false,
            reset: false,
            prev: false,
            next: false,
            play: {
              show: false,
            },
            rotateLeft: false,
            rotateRight: false,
            flipHorizontal: false,
            flipVertical: false,
          },
        });
        leafletThumbnail.addEventListener('click', () => {
          viewer.show();
        });
      }
    });
  };



  const initialize = () => {
    const storeBadgesClient = new StoreBadges();
    storeBadgesClient.initialize(indexDiv);
    onClickActionsForAllButtons();
    viewerInit();
  }

  // 初期実行
  initialize();
});
